/**
 * Helper class to format or change values
 */
class FormatUtils {
    /**
     *
     * @param {string|int} number
     * @return {string}
     */
    static number(number) {
        return number
            ? number
                  .toString()
                  .trim()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0";
    }

    /**
     * Format Bank card numbers
     * @param {string} card_number
     * @return {string}
     */
    static card(card_number) {
        return card_number
            .toString()
            .trim()
            .replace(/\B(?=(\d{4})+(?!\d))/g, " ");
    }

    /**
     * If value is null or empty or undefined returns the char
     * @param {*} value value that needs to check
     * @param {string} char char to return if value is null or empty or undefined
     * @return {string}
     */
    static null(value, char = " ") {
        if (value === null || value === undefined || value === "") {
            return char;
        } else {
            return value;
        }
    }

    /**
     * Format mobile as 0912 345 6789
     * @param {string} mobile
     * @return {string}
     */
    static mobile(mobile) {
        const mobile_str =
            mobile.toString().length === 11
                ? mobile.toString()
                : "0" + mobile.toString();
        return mobile_str.trim().replace(/(\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
    }
}

export default FormatUtils;
export { FormatUtils };
